export default "__VITE_ASSET__Cy$nM34d__"